module.exports = __webpack_public_path__ + "img/buy_normal_ph.d9e5b034.png";